import * as stylex from "@stylexjs/stylex";
import { spacing } from "@softmax/design-system/tokens.stylex";

import type {
  StoreDiagramBoard,
  StorePlayerBuildSample,
  StoreDiagramFeatured,
} from "./play-diagram-records";
import { PlayerBuildCard } from "./player-build-card";
import { Scoreboard } from "./diagram-scoreboard";
import { Frame } from "./diagram-frame";
import { Caption } from "./diagram-caption";
import { Arrow } from "./diagram-arrow";
import { BoardArtifact } from "./diagram-board-artifact";

export function HowYouPlayDiagram({
  sample,
  featured,
  board,
  cadence,
  scoreLabel,
  fig = "b",
}: {
  readonly sample: StorePlayerBuildSample;
  readonly featured: StoreDiagramFeatured | null;
  readonly board: StoreDiagramBoard;
  readonly cadence: string | null;
  readonly scoreLabel: string;
  readonly fig?: "a" | "b";
}) {
  return (
    <div id="how-you-play-figure" {...stylex.props(styles.container)}>
      <div {...stylex.props(styles.figure)}>
        <Frame at="card">
          <PlayerBuildCard sample={sample} fig={fig} />
        </Frame>
        <Caption
          at="card"
          lead="AI writes your bot"
          sub="from your instructions"
        />
        <Arrow at="first" />
        <Frame at="board">
          <BoardArtifact board={board} />
        </Frame>
        <Caption
          at="board"
          lead="Your bot plays"
          sub={cadence ? `a round ${cadence}` : null}
        />
        <Arrow at="second" />
        <Frame at="standings">
          <Scoreboard featured={featured} scoreLabel={scoreLabel} />
        </Frame>
        <Caption
          at="standings"
          lead="You guide the AI"
          sub={`using your bot’s ${scoreLabel}`}
        />
      </div>
    </div>
  );
}
const styles = stylex.create({
  container: { containerType: "inline-size", width: "100%", minWidth: 0 },
  figure: {
    display: {
      default: "grid",
      "@container (min-width: 560px)": "inline-grid",
    },
    gridTemplateColumns: {
      default: "1fr",
      "@container (min-width: 560px)": "176px 20px 176px 20px 176px",
      "@container (min-width: 700px)": "216px 32px 216px 32px 216px",
    },
    gridTemplateRows: {
      default: "auto",
      "@container (min-width: 560px)": "224px auto",
      "@container (min-width: 700px)": "260px auto",
    },
    rowGap: { default: spacing.space12, "@container (min-width: 560px)": 0 },
    columnGap: 0,
    alignItems: "start",
  },
});
